import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { EcommerceCardComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import heros from "../../assets/data/heros.json";
import axios from "axios";
import { BASE_URL, CURRENT_IP, TOKEN } from "../../helper/BASE_URL";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ClientsTableComponent } from "../../components/tables";
import ProgressBar from "../../components/ProgressBar";

export default function EcommercePage() {
  const { t, n } = useContext(TranslatorContext);
  const [setsponserCode, setSetsponserCode] = useState("");
  const [getData, setGetData] = useState([
    {
      icon: "account_circle",
      trend: "attach_money",
      title: "PPM Farm Bal",
      variant: "purple",
      number: 0.0,
      percent: 95,
    },
    {
      icon: "shopping_cart",
      trend: "trending_down",
      title: "PPM App Bal",
      variant: "green",
      number: 0.0,
      percent: 30,
    },
    {
      icon: "shopping_bag",
      trend: "trending_down",
      title: "PPM Farm Swapped BOP",
      variant: "blue",
      number: 0.0,
      percent: 25,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "PPM App Swapped BOP",
      variant: "yellow",
      number: 0.0,
      percent: 45,
    },
    {
      icon: "account_circle",
      trend: "attach_money",
      title: "coin price",
      variant: "green",
      number: 0.0,
      percent: 95,
    },
    {
      icon: "shopping_cart",
      trend: "trending_down",
      title: "My Directs",
      variant: "purple",
      number: 0.0,
      percent: 30,
    },
    {
      icon: "shopping_bag",
      trend: "trending_down",
      title: "total paid referrals",
      variant: "blue",
      number: 0.0,
      percent: 25,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "total earnings",
      variant: "yellow",
      number: 0.0,
      percent: 45,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "My Total Earnings",
      variant: "purple",
      number: 0.0,
      percent: 45,
    },
    {
      icon: "account_circle",
      trend: "trending_up",
      title: "PPM Wallet",
      variant: "green",
      number: 0.0,
      percent: 95,
    },
    {
      icon: "shopping_cart",
      trend: "trending_down",
      title: "Panda 11 Wallet",
      variant: "purple",
      number: 0.0,
      percent: 30,
    },
    {
      icon: "shopping_bag",
      trend: "trending_down",
      title: "level incomes earned",
      variant: "blue",
      number: 0.0,
      percent: 25,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "total coins purchase",
      variant: "yellow",
      number: 0.0,
      percent: 45,
    },
    {
      icon: "hotel_class",
      trend: "trending_up",
      title: "total coins usd value",
      variant: "purple",
      number: 0.0,
      percent: 45,
    },
  ]);

  const [ProgressBars, setProgressBar] = useState({
    current_bounty_number: 0,
    current_bounty_start_value: 0,
    current_bounty_target_value: 0,
    purchased_coins: 0,
    current_boutny_filled_percentage: 0,
    next_bounty_number: 0,
    next_bounty_start_value: 0,
    next_bounty_target_value: 0,
  });

  const [getDataas, setGetDataas] = useState(null);

  const [get_coin_purchase_log, setGet_coin_purchase_log] = useState([]);

  useEffect(() => {
    getDashData();
    getProgressBarData();
    getTableData();
  }, []);

  const getDashData = () => {
    const getData = localStorage.getItem("jwt");
    const parseIt = JSON.parse(getData);

    if (!parseIt) {
      localStorage.removeItem("jwt");
      window.location.replace("/");
    }

    try {
      axios
        .post(
          BASE_URL + "get_dashboard_data.php",
          {
            userid: parseIt.reg_em,
            token: parseIt.boss_token,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          let Data = acc.data.data;

          setGetData([
            {
              icon: "account_circle",
              trend: "attach_money",
              title: "PPM Farm Bal",
              variant: "blue",
              number: Data.panda_farm_balance_ppm,
              percent: 95,
            },
            {
              icon: "shopping_cart",
              trend: "trending_down",
              title: "PPM App Bal",
              variant: "yellow",
              number: Number(Data.panda_chat_balance_ppm).toFixed(2),
              percent: 30,
            },
            {
              icon: "shopping_bag",
              trend: "trending_down",
              title: "PPM Farm Swapped BOP",
              variant: "purple",
              number: Number(Data.swap_farm_balance_bopc).toFixed(2),
              percent: 25,
            },
            {
              icon: "hotel_class",
              trend: "trending_up",
              title: "PPM App Swapped BOP",
              variant: "green",
              number: Number(Data.swap_chat_balance_bopc).toFixed(2),
              percent: 45,
            },
            {
              icon: "account_circle",
              trend: "attach_money",
              title: "Coin Price",
              variant: "green",
              number: Data.coin_price,
              percent: 95,
            },
            {
              icon: "hotel_class",
              trend: "request_quote",
              title: "My BOP Tokens",
              variant: "purple",
              number: Data.my_bop_coins,
              percent: 45,
            },
            {
              icon: "hotel_class",
              trend: "trending_up",
              title: "My BOP USD Value",
              variant: "yellow",
              number: Data.my_bop_usd_value,
              percent: 45,
            },
            {
              icon: "hotel_class",
              trend: "account_balance_wallet",
              title: "My Bounty Tickets",
              variant: "blue",
              number: Data.my_bounty_tickets,
              percent: 45,
            },
            {
              icon: "shopping_cart",
              trend: "business_center",
              title: "Bounty Pool Eligibilty",
              variant: "blue",
              number: Data.bounty_pool_eligibility,
              percent: 30,
            },

            {
              icon: "hotel_class",
              trend: "money_bag",
              title: "My Total Earnings",
              variant: "yellow",
              number: Data.my_total_earnings,
              percent: 45,
            },
            {
              icon: "shopping_cart",
              trend: "lan",
              title: "My Directs",
              variant: "purple",
              number: Data.my_directs,
              percent: 30,
            },
            {
              icon: "shopping_bag",
              trend: "payments",
              title: "My Team",
              variant: "green",
              number: Data.my_team,
              percent: 25,
            },

            {
              icon: "shopping_bag",
              trend: "call_split",
              title: "My Wallet Balance",
              variant: "green",
              number: Data.my_wallet_balance,
              percent: 25,
            },
            {
              icon: "account_circle",
              trend: "business_center",
              title: "PPM V2.0 Status",
              variant: "purple",
              number: Data.ppm_status,
              percent: 95,
            },
            {
              icon: "shopping_cart",
              trend: "business_center",
              title: "Panda 11 Wallet Balance",
              variant: "yellow",
              number: Data.panda_11_wallet_bal,
              percent: 30,
            },
            {
              icon: "shopping_cart",
              trend: "business_center",
              title: "Panda Meet Status",
              variant: "blue",
              number: Data.panda_meet_status,
              percent: 30,
            },
          ]);
        })
        .catch((err) => {});
    } catch (error) {}
  };

  const getProgressBarData = () => {
    const getData = localStorage.getItem("jwt");
    const parseIt = JSON.parse(getData);
    if (!parseIt) {
      localStorage.removeItem("jwt");
      window.location.replace("/");
    }

    try {
      axios
        .post(
          BASE_URL + "get_latest_bounty_details.php",
          {
            userid: parseIt.reg_em,
            token: parseIt.boss_token,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          setProgressBar(acc.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getTableData = () => {
    const getData = localStorage.getItem("jwt");
    const parseIt = JSON.parse(getData);

    if (!parseIt) {
      localStorage.removeItem("jwt");
      window.location.replace("/");
    }

    try {
      axios
        .post(
          BASE_URL + "get_coin_purchase_log.php",
          {
            userid: parseIt.reg_em,
            token: parseIt.boss_token,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);
          let logs = acc.data.data.purchase_list.find(
            (e) => e == "NO RECORDS FOUND"
          );

          if (!logs) {
            setGet_coin_purchase_log(acc.data.data.purchase_list);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("COPIED ✅");
    });
  };

  useEffect(() => {
    Handle_Enter_OTP();
  }, []);

  const Handle_Enter_OTP = () => {
    const getData = localStorage.getItem("jwt");
    const parseIt = JSON.parse(getData);

    try {
      axios
        .post(
          BASE_URL + "get_user_profile.php",
          {
            userid: parseIt.reg_em,
            token: parseIt.boss_token,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log("xxxxxx");
          console.log(acc.data.data.reg_date);
          console.log("xxxxxx");

          let gettingDate = acc.data.data.reg_date;

          let dateObj = new Date(gettingDate);

          let cutoffDate = new Date("2024-09-01T00:00:00Z");

          let isBeforeSeptember1st = dateObj < cutoffDate;

          setGetDataas(isBeforeSeptember1st);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <PageLayout>
      <ToastContainer />
      <div style={{ overflowY: "auto", overflowX: "hidden", height: "80vh" }}>
        <Row>
          <Col xl={12}>
            <div className="mc-card">
              <div className="mc-breadcrumb">
                <h3 className="mc-breadcrumb-title">{t("DASHBOARD")}</h3>
              </div>
            </div>
          </Col>

          <style>
            {`
    @keyframes blinker {
      50% { opacity: 0; } // Text blinking effect
    }
  `}
          </style>
          <Col xl={12}>
            <div
              style={{
                top: 0,
                backgroundColor: "rgb(234 16 19 / 80%)",
                padding: "2px",
                marginBottom: 20,
                borderRadius: 5,
                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.4)", // Border shadow effect
              }}
            >
              <marquee
                scrollamount="12"
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "300",
                }}
              >
                Welcome to Boss Panda. The world's best meme token with real
                products, dedicated team and cutting edge technology. Boss Panda
                pre-sale offer first sale of 200,000,000 BOP tokens @
                $0.0000500. Buy $100 worth tokens and become a VIP member. VIP's
                get 1 Bounty ticket with a chance to win iPhone, iPad, MacBook
                and more. All your Bounty tickets will enter the Bounty pool and
                you can get $100k. You also get 9 levels referral bonus and 2x
                Buy Back Bonus. Buy BOP Tokens before the price increases. Next
                round 200,000,000 BOP tokens offer price: $0.0000525 BUY NOW NOW
                NOW!!!
              </marquee>
            </div>
          </Col>
          <Col xs={12} xl={12}>
            <Row xs={1} sm={4}>
              {getData.slice(getDataas ? 0 : 4).map((hero, index) => (
                <Col key={index}>
                  <EcommerceCardComponent
                    icon={hero.icon}
                    trend={hero.trend}
                    title={hero.title}
                    variant={hero.variant}
                    number={hero.number}
                    percent={hero.percent}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <div
          style={{
            top: 0,
            backgroundColor: "rgb(234 16 19 / 80%)",
            padding: "2px",
            marginBottom: 20,
            borderRadius: 5,
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.4)", // Border shadow effect
          }}
        >
          <marquee
            scrollamount="12"
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "300",
            }}
          >
            Bounty -1 winner : To be announced soon. Bounty -1 winner gets Apple
            Macbook AIR. All your Bounty tickets will enter Bounty Pool and you
            can get $100k as bonus rewards.
          </marquee>
        </div>

        <style>
          {`
    @keyframes blinker {
      50% { opacity: 0; } // Text blinking effect
    }
  `}
        </style>

        <Row
          style={{
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 13px",
          }}
        >
          <Col xl={6}>
            <div
              style={{
                background: "linear-gradient(to left, #4eda89, #1a9f53)",
                borderRadius: "15px",

                marginTop: "5px",
              }}
            >
              <div className="mc-breadcrumb">
                <h3
                  style={{ marginTop: "10px", marginLeft: "20px" }}
                  className="mc-breadcrumb-title"
                >
                  {t("Current Bounty - 1")}
                </h3>
                <h3
                  style={{ marginTop: "10px", marginRight: "20px" }}
                  className="mc-breadcrumb-title"
                >
                  Tickets Sold: 34
                </h3>
              </div>
              <ProgressBar
                progress={ProgressBars.current_boutny_filled_percentage}
                bounty={ProgressBars.current_bounty_target_value}
                bounty2={ProgressBars.total_token_sale}
                fvalue={ProgressBars.total_token_sale}
              />
            </div>
          </Col>
          <Col xl={6}>
            <div
              style={{
                background: "linear-gradient(to left, #f4d02b, #e1940e)",
                borderRadius: "15px",
                marginTop: "5px",
              }}
            >
              <div className="mc-breadcrumb">
                <h3
                  style={{ marginTop: "10px", marginLeft: "20px" }}
                  className="mc-breadcrumb-title"
                >
                  {t("Next Bounty")}
                </h3>
                <h3
                  style={{ marginTop: "10px", marginRight: "20px" }}
                  className="mc-breadcrumb-title"
                >
                  BOP Next Coin Price = 0.000052
                  {"  "}
                </h3>
              </div>
              <ProgressBar
                progress={"Ignore"}
                bounty={ProgressBars.next_bounty_target_value}
                fvalue={ProgressBars.purchased_coins}
              />
            </div>
          </Col>
        </Row>

        <h5
          style={{
            marginTop: 30,
            marginBottom: -10,
            fontWeight: "bold",
            marginLeft: 5,
          }}
        >
          Referral Link
        </h5>
        <br />
        <div className="input-group mb-3 ml-5 mr-5">
          <input
            value={`https://bosspandasale.vercel.app?ref=${
              typeof window !== "undefined" &&
              JSON.parse(window.localStorage.getItem("jwt")).boss_token
            }`}
            type="text"
            className="form-control text-white"
            aria-label="Amount (to the nearest dollar)"
          />
          <div className="input-group-append">
            <span
              className="input-group-text"
              style={{ cursor: "pointer" }}
              onClick={() =>
                handleCopy(
                  `https://bosspandasale.vercel.app?ref=${
                    typeof window !== "undefined" &&
                    JSON.parse(window.localStorage.getItem("jwt")).boss_token
                  }`
                )
              }
            >
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={30}
                fill="currentColor"
                className="bi bi-clipboard2-check"
                viewBox="0 0 16 16"
              >
                <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
                <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
                <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
              </svg> */}

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={30}
                fill="currentColor"
                className="bi bi-copy"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div style={{ marginTop: 35 }}>
          <h5 style={{ marginTop: 3, marginBottom: 10, fontWeight: "bold" }}>
            My 2x Bounty Table
          </h5>

          <div className="mc-table-responsive">
            <table className="mc-table">
              <thead className="mc-table-head">
                <tr>
                  {[
                    "Sno",
                    "Amount",
                    "Coin Price",
                    "Total Coin Purchase",
                    "Coin 2x Price",
                  ].map((item, index) => (
                    <th key={index}>{item}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="mc-table-body">
                {get_coin_purchase_log.map((item, index) => (
                  <tr key={index}>
                    <td style={{ width: "8px" }}>{index + 1}</td>
                    <td>{item.usd_amount}</td>
                    <td>{item.coin_price}</td>
                    <td>{item.total_coins_purchased}</td>
                    <td>{item.coin_2x_price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
